import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../../assets/logos/Proposio-Logo-Transparent.png';
import Button from 'components/ui/buttons/Button';
import { ROUTES } from '../../../config/route-configuration';

const PublicHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header className="w-full border-b border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to={ROUTES.HOME} className="flex items-center">
          <img src={logo} alt="Proposio logo" className="h-12" />
        </Link>

        <div className="flex items-center space-x-3">
          <Button variant="secondary" onClick={() => navigate(ROUTES.LOGIN)}>
            Sign in
          </Button>
          <Button onClick={() => navigate(ROUTES.SIGNUP)}>Get started</Button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
